import { default as us } from './us';

const tcMap: any = {
    us,
};

export default tcMap;
